import styled from 'styled-components'
import Select from 'react-select'
import { Link } from 'react-router-dom'

export const Bg = styled.div`
  min-height: 100vh;
  width: 100%;
  background: white;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background: white;
  min-height: 100vh;
`

export const PageContent = styled.div`
  padding: 0 2rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

/* ── Version tabs ── */
export const TabBar = styled.div`
  display: flex;
  gap: 0.375rem;
  background: #F3F4F6;
  border-radius: 10px;
  padding: 0.25rem;
  width: fit-content;
`

export const TabBtn = styled(Link)`
  font-family: Poppins;
  font-size: 0.85rem;
  font-weight: ${p => p.$active ? '600' : '500'};
  color: ${p => p.$active ? 'white' : '#6B7280'};
  background: ${p => p.$active ? 'linear-gradient(135deg, #00C4F3 0%, #6462FC 100%)' : 'transparent'};
  border-radius: 7px;
  padding: 0.45rem 1.5rem;
  text-decoration: none;
  transition: all 0.15s;
  box-shadow: ${p => p.$active ? '0 2px 8px rgba(100,98,252,0.25)' : 'none'};
  &:hover { color: ${p => p.$active ? 'white' : '#374151'}; }
`

/* ── Main grid card ── */
export const GridCard = styled.div`
  background: white;
  border-radius: 16px;
  border: 1px solid #E8EBF0;
  box-shadow: 0 4px 32px rgba(43,123,199,0.08);
  overflow: hidden;
`

export const GridCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #F0F1F5;
`

export const GridCardTitle = styled.span`
  font-family: Poppins;
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
`

export const GridCardSubtitle = styled.span`
  font-family: Poppins;
  font-size: 0.78rem;
  color: #9CA3AF;
  margin-left: 0.5rem;
`

/* ── Scale table ── */
export const ScaleTable = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
`

const COL_COLORS = {
  0: { bg: '#EEF2FF', border: '#C7D2FE', text: '#4F46E5', label: 'B' },
  1: { bg: '#EFF9FF', border: '#BAE6FD', text: '#0284C7', label: 'BEA' },
  2: { bg: '#F0FDF4', border: '#BBF7D0', text: '#16A34A', label: 'AAC' },
  3: { bg: '#FFF7ED', border: '#FED7AA', text: '#EA580C', label: 'BEA AAC' },
}

export const RowLabelCol = styled.div`
  width: 7rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding-top: 3.5rem;
`

export const RowLabel = styled.div`
  height: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1rem;
  font-family: Poppins;
  font-size: 0.72rem;
  color: #9CA3AF;
  border-bottom: 1px solid #F3F4F6;
  &:last-child { border-bottom: none; }
`

export const ScaleCol = styled.div`
  flex: 1;
  min-width: 7.5rem;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #F0F1F5;
`

export const ColHeader = styled.div`
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => COL_COLORS[p.$idx]?.bg || '#F9FAFB'};
  border-bottom: 2px solid ${p => COL_COLORS[p.$idx]?.border || '#E5E7EB'};
`

export const ColHeaderBadge = styled.span`
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 700;
  color: ${p => COL_COLORS[p.$idx]?.text || '#374151'};
  background: white;
  border: 1.5px solid ${p => COL_COLORS[p.$idx]?.border || '#E5E7EB'};
  border-radius: 100px;
  padding: 0.2rem 0.75rem;
`

export const CellWrapper = styled.div`
  height: 3.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => COL_COLORS[p.$idx]?.bg || 'white'}22;
  border-bottom: 1px solid #F3F4F6;
  transition: background 0.1s;
  &:last-child { border-bottom: none; }
  &:hover { background: ${p => COL_COLORS[p.$idx]?.bg || '#F9FAFB'}; }
`

export const Input = styled.input`
  width: 3.5rem;
  height: 2rem;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  text-align: center;
  background: white;
  border: 1.5px solid ${p => COL_COLORS[p.$idx]?.border || '#E5E7EB'};
  border-radius: 8px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  &:focus {
    border-color: ${p => COL_COLORS[p.$idx]?.text || '#6462FC'};
    box-shadow: 0 0 0 3px ${p => COL_COLORS[p.$idx]?.bg || '#EEF2FF'};
  }
`

/* ── Bottom bar ── */
export const GridBottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  border-top: 1px solid #F0F1F5;
  background: #FAFAFA;
`

export const ConfirmBtn = styled.button`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #00C4F3 0%, #6462FC 100%);
  border: none;
  border-radius: 10px;
  padding: 0.625rem 1.75rem;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(100,98,252,0.25);
  transition: opacity 0.15s, transform 0.15s;
  &:hover { opacity: 0.9; transform: translateY(-1px); }
  &:active { transform: translateY(0); }
`

/* ── Right panel ── */
export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 18rem;
  max-width: 22rem;
`

export const NoteCard = styled.div`
  background: #FFFBEB;
  border: 1px solid #FDE68A;
  border-radius: 12px;
  padding: 1rem 1.25rem;
`

export const NoteIcon = styled.div`
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
`

export const NoteText = styled.p`
  font-family: Poppins;
  font-size: 0.8rem;
  color: #92400E;
  line-height: 1.6;
  margin: 0;
`

export const SelectorCard = styled.div`
  background: white;
  border: 1px solid #E8EBF0;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 12px rgba(43,123,199,0.06);
`

export const SelectorCardTitle = styled.p`
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.75rem;
`

export const SelectorScaleEval = styled(Select)`
  .react-select__control {
    border-radius: 8px;
    font-family: Poppins;
    font-size: 0.8rem;
    border: 1.5px solid #D1D5DB;
    min-height: 2.5rem;
    cursor: pointer;
    &:hover { border-color: #9CA3AF; }
  }
  .react-select__control--is-focused {
    border-color: #6462FC !important;
    box-shadow: 0 0 0 3px rgba(100,98,252,0.12) !important;
  }
  .react-select__option {
    font-family: Poppins;
    font-size: 0.8rem;
    cursor: pointer;
  }
  .react-select__indicator-separator { display: none; }
  .react-select__dropdown-indicator { color: #9CA3AF; }
`

export const ValidateBtn = styled.button`
  width: 100%;
  margin-top: 0.75rem;
  font-family: Poppins;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${p => p.$active ? 'white' : '#9CA3AF'};
  background: ${p => p.$active ? 'linear-gradient(135deg, #00C4F3 0%, #6462FC 100%)' : '#F3F4F6'};
  border: none;
  border-radius: 8px;
  padding: 0.6rem;
  cursor: ${p => p.$active ? 'pointer' : 'default'};
  transition: opacity 0.15s;
  box-shadow: ${p => p.$active ? '0 4px 12px rgba(100,98,252,0.2)' : 'none'};
  &:hover { opacity: ${p => p.$active ? '0.9' : '1'}; }
`

/* ── Success toast ── */
export const SuccessToast = styled.div`
  position: fixed;
  top: 1.5rem;
  right: 2rem;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: white;
  border: 1px solid #BBF7D0;
  border-radius: 12px;
  padding: 0.875rem 1.25rem;
  box-shadow: 0 8px 32px rgba(22,163,74,0.15);
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 500;
  color: #15803D;
  animation: slideIn 0.25s ease;
  @keyframes slideIn {
    from { transform: translateX(2rem); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
  }
`

/* keep these for compat */
export const MainContainer = styled.div`display:flex;gap:2rem;align-items:flex-start;`
export const ScalesContainer = styled.div`flex:1;`
export const ScalesRightOptionsContainer = styled.div``
export const SelectorContainer = styled.div``
export const SelectorScaleEvalContainer = styled.div``
export const SelectorText = styled.p``
export const InfoContainer = styled.div``
export const FilterText = styled.div``
export const ScalesGridContainer = styled.div``
export const ScaleColumn = styled.div``
export const ScalesGridText = styled.span``
export const ScalesInfoContainer = styled.div``
export const ScalesVersion = styled(Link)``
export const ScalesGridBottomContainer = styled.div``
export const Button = styled.button``
export const Success = styled.div``
export const TextSuccess = styled.div``
export const ImgSuccess = styled.img``
